"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DatePicker = void 0;
const text_input_1 = require("../text-input");
const react_1 = __importStar(require("react"));
const react_datepicker_1 = __importDefault(require("react-datepicker"));
const icons_1 = require("../icons");
require("react-datepicker/dist/react-datepicker.css");
require("./styles.scss");
const moment_1 = __importDefault(require("moment"));
const DatePicker = (props) => {
    const { date, onChange, showTime = false, format, error, minDate, maxDate, timeGranularity = 10, label } = props;
    let pickerFormat = format;
    if (!pickerFormat) {
        pickerFormat = showTime ? "dd MMM, yyyy HH:mm" : "dd MMM, yyyy";
    }
    const pickerRef = (0, react_1.useRef)(null);
    const InputComponent = (0, react_1.forwardRef)(({ value, onClick }, ref) => {
        return (react_1.default.createElement("span", { ref: ref },
            react_1.default.createElement(text_input_1.TextInput, { onClick: onClick, value: value || "" })));
    });
    const labelLink = new Date().getTime().toString() + Math.random().toString();
    const filterTime = (time) => {
        const isMinBoundValid = minDate ? (0, moment_1.default)(time).isSameOrAfter(minDate) : true;
        const isMaxBoundValid = maxDate ? (0, moment_1.default)(time).isSameOrBefore(maxDate) : true;
        return isMaxBoundValid && isMinBoundValid;
    };
    const filterDate = (date) => {
        const isMinBoundValid = minDate ? (0, moment_1.default)(date).isSameOrAfter(minDate, "date") : true;
        const isMaxBoundValid = maxDate ? (0, moment_1.default)(date).isSameOrBefore(maxDate, "date") : true;
        return isMaxBoundValid && isMinBoundValid;
    };
    return (react_1.default.createElement("div", { className: "c-date-picker" },
        label && (react_1.default.createElement("label", { htmlFor: labelLink, className: "c-date-picker__label" }, label)),
        react_1.default.createElement("div", { className: "c-date-picker__calendar" },
            react_1.default.createElement(react_datepicker_1.default, { ref: pickerRef, isClearable: true, id: labelLink, customInput: react_1.default.createElement(InputComponent, null), selected: date, minDate: minDate, onChange: (value) => onChange === null || onChange === void 0 ? void 0 : onChange(value || undefined), showTimeSelect: showTime, timeIntervals: timeGranularity, dateFormat: pickerFormat, timeFormat: "HH:mm", filterTime: filterTime, filterDate: filterDate }),
            !date && (react_1.default.createElement("div", { onClick: () => { var _a; return (_a = pickerRef.current) === null || _a === void 0 ? void 0 : _a.setOpen(true); }, className: "c-date-picker__calendar-icon" },
                react_1.default.createElement(icons_1.CalendarIcon, null))),
            error && react_1.default.createElement("span", { className: "c-date-picker__validation" }, error))));
};
exports.DatePicker = DatePicker;
